export default __webpack_public_path__ + "static/media/alert-icon-2.3e26cf24.svg";